import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1db7c60b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkout_div" }
const _hoisted_2 = {
  key: 0,
  class: "checkout_loading_div"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "border_div" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "border_div" }, null, -1))
const _hoisted_5 = { class: "address_new_content" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Please add your Shipping Address ")
const _hoisted_7 = { class: "panel_div" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel_title" }, "Product List", -1))
const _hoisted_9 = { class: "panel_div" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel_title" }, "Payment Method", -1))
const _hoisted_11 = { class: "pay_type_div" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("M-PESA")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Online Payments")
const _hoisted_14 = { class: "panel_div" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel_title" }, "Discount", -1))
const _hoisted_16 = { class: "vouncher_div" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Voucher", -1))
const _hoisted_18 = {
  key: 0,
  class: "price_div"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Select ")
const _hoisted_20 = {
  key: 0,
  class: "coins_div"
}
const _hoisted_21 = { class: "coins_check" }
const _hoisted_22 = {
  key: 1,
  class: "anniversary_div"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Free Shipping ")
const _hoisted_24 = { class: "panel_div" }
const _hoisted_25 = { class: "submit_div" }
const _hoisted_26 = { class: "submit_price_div" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Pay Amount ")
const _hoisted_28 = { class: "submit_btn" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Pay Now")
const _hoisted_30 = { class: "mpase_content_div" }
const _hoisted_31 = {
  key: 0,
  class: "m_pesa_phone_msg"
}
const _hoisted_32 = { class: "proceed_div" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Proceed")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_menu = _resolveComponent("header-menu")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_Address = _resolveComponent("Address")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_order_goods = _resolveComponent("order-goods")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_order_price = _resolveComponent("order-price")!
  const _component_checkout_voucher = _resolveComponent("checkout-voucher")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_header_menu, {
      title: "Place Order",
      backgroundColor: "white",
      fontColor: "#190900"
    }),
    ($setup.is_loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_van_loading, { size: "48" })
        ]))
      : _createCommentVNode("", true),
    (_ctx.buy_loding || $setup.address_item && $setup.address_item.address_id)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.fn_go_back($setup.address_item.address_id) )),
          class: "address_div"
        }, [
          _hoisted_3,
          _createElementVNode("div", null, [
            _createVNode(_component_Address, {
              address_message: false,
              item: $setup.address_item
            }, null, 8, ["item"])
          ]),
          _hoisted_4
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.router.push('address-adds?is_checkout=1'))),
          class: "address_new"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_van_icon, {
              name: "plus",
              size: "10px"
            }),
            _hoisted_6
          ])
        ])),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.goods_list, (item, index) => {
          return (_openBlock(), _createBlock(_component_order_goods, {
            good_item: item,
            key: 'ck_goods_'+ index
          }, null, 8, ["good_item"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_van_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.pay_type = '1')),
          plain: "",
          type: $setup.pay_type === '1'? 'primary': 'default' 
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_component_van_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.pay_type = '2')),
          plain: "",
          type: $setup.pay_type === '2'? 'primary': 'default' 
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["type"])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        ($setup.order_price_obj.goods_discount)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, "-" + _toDisplayString($setup.currencyUnit) + " " + _toDisplayString($setup.order_price_obj.goods_discount.thousands()), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "select_div",
          onClick: _cache[4] || (_cache[4] = ($event: any) => {$setup.voucher_type = 'voucher_type';$setup.voucher_show = true;})
        }, [
          _hoisted_19,
          _createVNode(_component_van_icon, { name: "arrow" })
        ])
      ]),
      ($setup.cash_rewards_info_max)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("div", null, _toDisplayString($setup.cash_rewards_info_max) + " Coins To Be Redeemed ", 1),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_van_checkbox, {
                "icon-size": "20px",
                onClick: $setup.cash_rewards_check_fn,
                modelValue: $setup.check_cash_redeemed,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.check_cash_redeemed) = $event))
              }, null, 8, ["onClick", "modelValue"])
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.order_price_obj.shipping_discount_amount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", null, "- KSh " + _toDisplayString($setup.order_price_obj.shipping_discount_amount), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createVNode(_component_order_price, { order_price_obj: $setup.order_price_obj }, null, 8, ["order_price_obj"])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("b", null, _toDisplayString($setup.currencyUnit) + " " + _toDisplayString($setup.order_price_obj.pay_amount.thousands()), 1)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_van_button, {
          loading: $setup.submit_loading,
          type: "primary",
          onClick: $setup.submit_btn_fn
        }, {
          default: _withCtx(() => [
            _hoisted_29
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ]),
    _createVNode(_component_van_action_sheet, {
      show: $setup.voucher_show,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => (($setup.voucher_show) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_checkout_voucher, {
          voucher_type: $setup.voucher_type,
          voucher_show: $setup.voucher_show,
          onHide_voucher_show: _cache[6] || (_cache[6] = ($event: any) => ($setup.voucher_show = false)),
          goods_discount: $setup.order_price_obj.goods_discount,
          amount: $setup.order_price_obj.pay_amount,
          voucher_code: $setup.voucher_code,
          voucher_list: $setup.voucher_list,
          onCallback: $setup.voucher_call_back_fn
        }, null, 8, ["voucher_type", "voucher_show", "goods_discount", "amount", "voucher_code", "voucher_list", "onCallback"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_action_sheet, {
      show: $setup.m_pesa_show,
      "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => (($setup.m_pesa_show) = $event)),
      title: "Enter the M-PESA Account"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_30, [
          _withDirectives(_createElementVNode("input", {
            ref: "mpesa_mobile",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.m_pesa_phone) = $event)),
            type: "text",
            placeholder: "Please enter your phone number"
          }, null, 512), [
            [_vModelText, $setup.m_pesa_phone]
          ]),
          ($setup.m_pesa_error_msg_show)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, "Please enter a valid Mpesa number"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_van_button, {
              loading: $setup.mpesa_loading,
              type: "primary",
              onClick: $setup.m_pesa_submit_fn
            }, {
              default: _withCtx(() => [
                _hoisted_33
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}